import userStorage from "../../utils/userStorage";
import useGetDetectLive from "../useGetDetectLive";

// 주기적으로 호출해서 이벤트 감지하는 모니터링 훅
export const useGetMonitoring = () => {
  const user = userStorage.get();
  const { data, isSuccess, isLoading, isError, refetch } =
    useGetDetectLive({
      area: user?.area as string,
      mobility_code: -1,
      searchKey: "",
      page: 0,
      limit: 100,
      isDetect: true,
    });

  return { data, isSuccess, isLoading, isError, refetch };
};
